@if (snackbarData?.message) {
  <div
    #snackbar
    class="snackbar-wrapper"
    [ngClass]="snackbarData?.displayConfig?.panelClass"
  >
    @if (snackbarData?.iconConfig?.name) {
      <mat-icon
        [svgIcon]="snackbarData?.iconConfig?.name"
        [ngClass]="snackbarData?.iconConfig?.className"
      ></mat-icon>
    }
    <div class="align-self-center flex-1">
      <span
        class="twc-typography-body-1 flex-1 align-self-center pt-2 snackbar-label"
        [ngClass]="{
          'twc-typography-body-1-medium': snackbarData?.action?.actionText,
        }"
        [innerHTML]="snackbarData?.message"
      ></span>
      @if (snackbarData?.action?.actionText) {
        <div>
          <span
            class="text-decoration-underline cursor-pointer twc-typography-body-1-medium twc-color-link"
            (click)="onActionClick()"
          >
            {{ snackbarData?.action?.actionText }}
          </span>
        </div>
      }
    </div>
    <mat-icon
      class="cursor-pointer ml-8 twc-color-secondary-typeface close-icon"
      svgIcon="twc:close-2"
      (click)="removeSnackbar(snackbarData?.id)"
    ></mat-icon>
  </div>
}
